// extracted by extract-css-chunks-webpack-plugin
module.exports = {"reaction_activity":"ReactionActivity__reaction_activity--3q66b","reactions":"ReactionActivity__reactions--1H8XQ"};